import React from 'react'
import './contact.scss'

const Contact = () => {
  return (
    <div className="contact">
        <div className="textContainer">
            <h1>Let's Work Together</h1>
            <div className="item">
                <h2>Mail</h2>
                <span>contact@arrowdigitalmarketing.com</span>
            </div>

            <div className="item">
                <h2>Address</h2>
                <span>Advant Tower, Sector-142 Noida</span>
            </div>

            <div className="item">
                <h2>Mobile</h2>
                <span>+91-8952-454-879</span>
            </div>
        </div>
        <div className="formContainer">
            
            <form action="">
                <input type="name" required placeholder='Enter name' />
                <input type="email" required placeholder='Enter email' />
                <input type="number" required placeholder='Enter mobile number' />
                <textarea name="" id="" rows={8} placeholder='Message'/>
                <button>Submit</button>
            </form>


        </div>
    </div>
  )
}

export default Contact